import { Directive } from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Directive({
    selector: "[appCustomTooltip]",
    standalone: false,
    hostDirectives: [
        {
            directive: NgbTooltip,
            inputs: ['ngbTooltip: appCustomTooltip', 'placement', 'container', 'triggers', 'autoClose', 'tooltipClass']
        }
    ]
})
export class CustomTooltipDirective {
    constructor(private ngbTooltip: NgbTooltip) {
            this.ngbTooltip.triggers = 'mouseover:mouseleave';
        }
    
        ngOnInit() {
            // Set default values if not overridden
            if (!this.ngbTooltip.tooltipClass) {
                this.ngbTooltip.tooltipClass = 'custom_tooltip';
            }
            if (!this.ngbTooltip.container) {
                this.ngbTooltip.container = 'body';
            }
            if (!this.ngbTooltip.placement) {
                this.ngbTooltip.placement = 'top';
            }
            // Only override triggers if not explicitly set in HTML
            if (!this.ngbTooltip.triggers || this.ngbTooltip.triggers === 'hover focus') {
                this.ngbTooltip.triggers = 'mouseover:mouseleave';
            }
            this.ngbTooltip.autoClose = true;
        }
    
}
